export default class UserInformationView {
    constructor(json) {
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.email = json.email;
        this.admin = json.admin;
        this.superAdmin = json.superAdmin;
        this.active = json.active;
        this.assignedLocations = json.assignedLocations;
        this.teams = json.teams;
        this.licenseActive = json.licenseActive;
        this.manager = json.manager;
        this.analyst = json.analyst;
        this.oldUser = json.oldUser;

        this.information = {
            lastLogin: json.lastLogin ? new Date(json.lastLogin) : '-',
            registeredAt: json.registeredAt ? new Date(json.registeredAt) : '-',
            passwordResetActive: json.passwordResetActive,
            anonymizationActive: json.anonymizationActive,
            locale: json.locale || '-',
            timezone: json.timezone || '-',
            accountType: json.accountType,
            azureId: json.azureId,
            googleId: json.googleId,
            oidcId: json.oidcId,
            temporarySsoId: json.temporarySsoId,
            temporarySsoType: json.temporarySsoType,
            lastFailedLoginAttempt: json.lastFailedLoginAttempt
                ? new Date(json.lastFailedLoginAttempt)
                : '-',
            failedAttempts: json.failedAttempts,
            locked: json.locked,
        };
    }
}
